import EmblaCarousel from "embla-carousel";
import {
  disablePrevNextBtns,
  lazeload,
  selectDotBtn,
  setupDotBtns,
  setupPrevNextBtns,
} from "./embla";

export default function EmblaIntialization({
  rootNode = null,
  options = {},
  plugins = [],
  slideType = "",
  navigation = {
    show: false,
    prevNode: null,
    nextNode: null,
    disable: false,
  },
  pagination = {
    show: false,
    template: `<button aria-label="${slideType} Pagination" class="embla__dot" type="button"></button>`,
    dotsNode: null,
  },
  lazyLoad = false,
  IsHomepageMainBanner = false,
  IsHomepageTopPicks = false,
  HasSliderClick = false,
  HasNameInDots = false,
}) {
  if (rootNode && rootNode !== null) {
    //Initialize the Home embla carousel
    const Embla = EmblaCarousel(rootNode, { ...options }, plugins);

    // Adding active class for embla slide when it is active;

    Embla.on("select", () => {
      const activeCls = "is-active";
      const currentSlideIndex = Embla.selectedScrollSnap();
      const emblaContainer = rootNode.querySelector(".embla__container");
      const prevSlide = emblaContainer.querySelector(
        `.embla__slide.${activeCls}`,
      );
      const AllSlides = emblaContainer.querySelectorAll(".embla__slide");
      if (prevSlide) {
        prevSlide.classList.remove(activeCls);
      }

      AllSlides.forEach((slideNode, index) => {
        if (currentSlideIndex === index) {
          slideNode.classList.add(activeCls);
        }
      });
    });

    // Lazyload
    if (lazyLoad) {
      const loadImagesInView = lazeload(Embla);
      const loadImagesInViewAndDestroyIfDone = (eventName) => {
        const loadedAll = loadImagesInView();

        if (loadedAll) Embla.off(eventName, loadImagesInViewAndDestroyIfDone);
      };

      Embla.on("init", loadImagesInViewAndDestroyIfDone);
      Embla.on("select", loadImagesInViewAndDestroyIfDone);
      Embla.on("resize", loadImagesInViewAndDestroyIfDone);
    }

    // Naviagtion
    const prevBtn = navigation.prevNode;
    const nextBtn = navigation.nextNode;
    if (
      navigation?.show &&
      prevBtn &&
      prevBtn !== null &&
      nextBtn &&
      nextBtn !== null
    ) {
      setupPrevNextBtns(prevBtn, nextBtn, Embla);

      if (navigation.disable) {
        const DisablePrevAndNextBtns = disablePrevNextBtns(
          prevBtn,
          nextBtn,
          Embla,
        );
        Embla.on("select", DisablePrevAndNextBtns);
        Embla.on("init", DisablePrevAndNextBtns);
      }

      Embla.on("init", () => {
        const hasScrollableContent =
          Embla.canScrollPrev() || Embla.canScrollNext();
        const hideStyle = hasScrollableContent ? "" : "none";
        prevBtn.style.display = hideStyle;
        nextBtn.style.display = hideStyle;
        if (pagination?.dotsNode) pagination.dotsNode.style.display = hideStyle;
      });
    }

    // Pagination

    const paginationNode = pagination.dotsNode;
    let dotsArray = [];

    if (pagination?.show && paginationNode && paginationNode !== null) {
      // Generate buttons

      const generateDotBtns = (dots, embla) => {
        // const template = pagination.template;
        const template = `<button class="embla__dot" aria-label="${slideType} Pagination" type="button"></button>`;
        dots.innerHTML = embla
          .scrollSnapList()
          .reduce((acc) => acc + template, "");
        return [].slice.call(dots.querySelectorAll(".embla__dot"));
      };

      // Paginations

      dotsArray = generateDotBtns(paginationNode, Embla);
      const setSelectedDotBtn = selectDotBtn(dotsArray, Embla);
      setupDotBtns(dotsArray, Embla);
      Embla.on("select", setSelectedDotBtn);
      Embla.on("init", setSelectedDotBtn);

      if (IsHomepageMainBanner || IsHomepageTopPicks || HasNameInDots) {
        const removeWords = [
          "promo codes",
          "promo code",
          "coupons",
          "coupon codes",
          "coupon code",
          "offers",
          "offer",
        ];

        dotsArray.forEach((dotEle, index) => {
          let dataMerchant =
            Embla.slideNodes()[index].getAttribute("data-merchant");
          dotEle.setAttribute("title", dataMerchant);
          removeWords.forEach((removeText, removeIndex) => {
            if (dataMerchant.toLowerCase().includes(removeText)) {
              dataMerchant = dataMerchant.toLowerCase().replace(removeText, "");
            }
          });

          dotEle.innerHTML = dataMerchant;
        });

        if (
          paginationNode &&
          paginationNode.clientWidth < paginationNode.scrollWidth
        ) {
          paginationNode.style.justifyContent = "flex-start";
        }

        Embla.on("select", () =>
          scrollActiveElementIntoView(rootNode, Embla.selectedScrollSnap()),
        );
        Embla.on("init", () =>
          scrollActiveElementIntoView(rootNode, Embla.selectedScrollSnap()),
        );
      }
    }

    // Slider Click

    if (HasSliderClick) {
      const onSlideClick = (slideNode) => {
        if (Embla.clickAllowed()) {
          const slideclick = slideNode.querySelector(".go-clicker");
          slideclick.click();
        }
      };

      Embla.slideNodes().forEach((slideNode, index) => {
        slideNode.addEventListener(
          "click",
          () => onSlideClick(slideNode),
          false,
        );
      });
    }

    // LOCAL ADDITION (not in the .in original): hand the instance back.
    // A carousel inside a hidden tab panel measures as zero width, so the
    // home page has to call reInit() the moment its panel becomes visible.
    // .in never needed this — it only ever rendered the first tab.
    return Embla;
  }

  return null;
}

function scrollActiveElementIntoView(rootNode, $activeIndex) {
  if ($activeIndex >= 0) {
    const $parent = rootNode.querySelector(".embla__dots");
    if ($parent && $parent !== null) {
      const $activeEle = [...$parent.querySelectorAll(".embla__dot")][
        $activeIndex
      ];
      if ($activeEle && $activeEle !== null) {
        const scrollLeftvalue =
          $activeEle.offsetLeft -
          ($parent.offsetWidth - $activeEle.offsetWidth) / 2;
        $parent.scrollLeft = scrollLeftvalue;
      }
    }
  }
}
